import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 物业区域基础数据管理
 */
export class EaAreaControllerSvr {
  constructor() {
    this.baseurl = 'EaAreaControllerSvr.assx/';
  }

  /**
   * 获取物业区域扩展信息
   * token:String, eaAreaCode:String
   */
  GetEaAreaProperty (token, eaAreaCode) {
    return request.post(
      this.baseurl + 'GetEaAreaProperty',
      Qs.stringify({
        token: token,
        eaAreaCode: eaAreaCode,
      })
    );
  }
  /**
   * 将审核通过的数据更新至年报报表
   * token:String, reportId:String
   */
  auditDataToReport (token, reportId) {
    return request.post(
      this.baseurl + 'auditDataToReport',
      Qs.stringify({ token: token, reportId: reportId })
    );
  }
  /**
       * 获取上一个物业服务企业
       * token:String, eaAreaExternalCount:String, keyId:String, applyType:int, applicationTime:String
       */
  getPastRealtyMngOrg (token, eaAreaExternalCount, keyId, applyType, applicationTime) {
    return request.post(this.baseurl + 'getPastRealtyMngOrg', Qs.stringify({ token: token, eaAreaExternalCount: eaAreaExternalCount, keyId: keyId, applyType: applyType, applicationTime: applicationTime }));
  }

  /**
   * 新增物业区域对象(如果有子对像则将同时新增)
   * token:String, eaArea:EaArea, isAddChild:boolean
   */
  AddEaArea (token, eaArea, isAddChild) {
    return request.post(
      this.baseurl + 'AddEaArea',
      Qs.stringify({
        token: token,
        eaArea:
          typeof eaArea === 'undefined' || eaArea === null
            ? ''
            : eaArea.toString(),
        isAddChild: isAddChild,
      })
    );
  }
  /**
   * 根据条件获取简单物业区域列表（未删除）。
   * token:String, param:EaAreaQueryParaEx, detail:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean, showAll:boolean, option:int, locationMapType:String
   */
  GetEaAreaListBySimple (
    token,
    param,
    detail,
    startIndex,
    maxSize,
    resultTotalCount,
    showAll,
    option,
    locationMapType
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaListBySimple',
      Qs.stringify({
        token: token,
        param:
          typeof param === 'undefined' || param === null
            ? ''
            : param.toString(),
        detail: detail,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        showAll: showAll,
        option: option,
        locationMapType: locationMapType,
      })
    );
  }
  /**
   * 根据条件返回物业区域列表（未删除）。
   * token:String, param:EaAreaQueryParaEx, detail:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean, showAll:boolean, option:int, locationMapType: String
   */
  GetEaAreaList (
    token,
    param,
    detail,
    startIndex,
    maxSize,
    resultTotalCount,
    showAll,
    option,
    locationMapType,
    subCompanyOrgCode,
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaList',
      Qs.stringify({
        token: token,
        param:
          typeof param === 'undefined' || param === null
            ? ''
            : param.toString(),
        detail: detail,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        showAll: showAll,
        option: option,
        locationMapType: locationMapType,
        subCompanyOrgCode
      })
    );
  }

  /**
   * 根据物业区域的编码返回物业区域对象
   * token:String, eaAreaCode:String, detail:boolean, child:boolean
   */
  GetEaAreaDetail (token, eaAreaCode, detail, child) {
    return request.post(
      this.baseurl + 'GetEaAreaDetail',
      Qs.stringify({
        token: token,
        eaAreaCode: eaAreaCode,
        detail: detail,
        child: child,
      })
    );
  }

  /**
   * 上传
   * request:HttpServletRequest, file:MultipartFile
   */
  Upload (request, file) {
    return request.post(
      this.baseurl + 'Upload',
      Qs.stringify({
        request:
          typeof request === 'undefined' || request === null
            ? ''
            : request.toString(),
        file:
          typeof file === 'undefined' || file === null ? '' : file.toString(),
      })
    );
  }

  /**
   * 修改物业区域对象。
   * token:String, eaArea:EaArea
   */
  ModifyEaArea (token, eaArea) {
    return request.post(
      this.baseurl + 'ModifyEaArea',
      Qs.stringify({
        token: token,
        eaArea:
          typeof eaArea === 'undefined' || eaArea === null
            ? ''
            : eaArea.toString(),
      })
    );
  }

  /**
   * 获取项目经理或者业委会的小区信息
   * token:String
   */
  GetEaAreaForManagerOrOwnerTeam (token) {
    return request.post(
      this.baseurl + 'GetEaAreaForManagerOrOwnerTeam',
      Qs.stringify({
        token: token,
      })
    );
  }

  /**
   * 删除物业区域对象。
   * token:String, eaAreaCode:String
   */
  DeleteEaArea (token, eaAreaCode) {
    return request.post(
      this.baseurl + 'DeleteEaArea',
      Qs.stringify({
        token: token,
        eaAreaCode: eaAreaCode,
      })
    );
  }
  /**
   * 根据条件返回导入项目物业区域列表
   * token:String, name:String, isInCity:int, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetEaAreaListByImportSzProject (
    token,
    name,
    isInCity,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaListByImportSzProject',
      Qs.stringify({
        token: token,
        name: name,
        isInCity: isInCity,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }
  /**
   * 修改导入物业项目
   * token:String, importSzProject:ImportSzProject, importantDocs:ImportantDocList
   */
  ModifyEaAreaListByImportSzProject (token, importSzProject, importantDocs) {
    return request.post(
      this.baseurl + 'ModifyEaAreaListByImportSzProject',
      Qs.stringify({
        token: token,
        importSzProject:
          typeof importSzProject === 'undefined' || importSzProject === null
            ? ''
            : importSzProject.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }
  /**
   * 删除导入物业项目
   * token:String, keyId:String
   */
  DeleteEaAreaListByImportSzProject (token, keyId) {
    return request.post(
      this.baseurl + 'DeleteEaAreaListByImportSzProject',
      Qs.stringify({ token: token, keyId: keyId })
    );
  }
  /**
   * 导入物业项目附件上传
   * token:String, keyId:String, importantDocs:ImportantDocList
   */
  ImportSzProjectByUpLoad (token, keyId, importantDocs) {
    return request.post(
      this.baseurl + 'ImportSzProjectByUpLoad',
      Qs.stringify({
        token: token,
        keyId: keyId,
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }
  /**
   * 根据条件返回导入项目物业区域详情
   * token:String, keyId:String
   */
  GetImportSzProjectDetail (token, keyId) {
    return request.post(
      this.baseurl + 'GetImportSzProjectDetail',
      Qs.stringify({ token: token, keyId: keyId })
    );
  }
  /**
   * 获取市外项目详情(主管部门)
   * token:String, eaAreaCode:String
   */
  GetEaAreaListBySzPropertyProject (token, eaAreaCode) {
    return request.post(
      this.baseurl + 'GetEaAreaListBySzPropertyProject',
      Qs.stringify({ token: token, eaAreaCode: eaAreaCode })
    );
  }
  /**
   * 获取附件数据
   * token:String, attachMentId:String
   */
  CheckImportantDocSecond (token, attachMentId) {
    return request.post(
      this.baseurl + 'CheckImportantDocSecond',
      Qs.stringify({ token: token, attachMentId: attachMentId })
    );
  }
  /**
   * 获取附件数据
   * token:String, attachMentId:String
   */
  checkImportantDocIgnoreStream (token, attachMentId) {
    return request.post(
      this.baseurl + 'CheckImportantDocIgnoreStream',
      Qs.stringify({ token: token, attachMentId: attachMentId })
    );
  }
  /**
   * 根据条件返回导入项目物业区域列表(主管部门)
   * token:String, name:String, orgName:String, isUpdate:int, checkStatus:int, isInCity:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetEaAreaListByImportSzProjectByPower (
    token,
    name,
    orgName,
    isUpdate,
    checkStatus,
    isInCity,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaListByImportSzProjectByPower',
      Qs.stringify({
        token: token,
        name: name,
        orgName: orgName,
        isUpdate: isUpdate,
        checkStatus: checkStatus,
        isInCity: isInCity,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }
  /**
   * 获取获取公司列表
   * token:String, eaAreaCode:String
   */
  GetOrgsByToken (token) {
    return request.post(
      this.baseurl + 'getOrgsByToken',
      Qs.stringify({ token: token })
    );
  }
  /**
   * 获取获取公司列表
   * token:String, eaAreaCode:String
   */
  GetNeedItem (token, itemNames) {
    return request.post(
      this.baseurl + 'getNeedItem',
      Qs.stringify({ token: token, itemNames: itemNames })
    );
  }
  /**
   * 企业在管项目审核
   * token:String, dataId:String, reportId:String, reviewStatus:String, remark:String,
   */
  AuditData (token, importSzProject, reportId) {
    return request.post(
      this.baseurl + 'auditData',
      Qs.stringify({
        token: token,
        importSzProject: importSzProject,
        reportId: reportId,
      })
    );
  }
  /**
   * 根据条件返回导入年报下的项目(主管部门)
   * token:String, name:String, orgName:String, isUpdate:int, checkStatus:int, isInCity:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetEaAreaListByImportSzProjectByPower1 (
    token,
    name,
    orgName,
    reviewStatus,
    isUpdate,
    checkStatus,
    reportId,
    isInCity,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'getEaAreaListByImportSzProjectByPower1',
      Qs.stringify({
        token: token,
        name: name,
        orgName: orgName,
        reviewStatus: reviewStatus,
        isUpdate: isUpdate,
        checkStatus: checkStatus,
        reportId: reportId,
        isInCity: isInCity,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }
  /**
   * 添加在管项目
   * token:String, name:String, orgName:String, isUpdate:int, checkStatus:int, isInCity:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  SaveImportSzProject (token, eaAreaProperty) {
    return request.post(
      this.baseurl + 'saveImportSzProject',
      Qs.stringify({
        token: token,
        importSzProject:
          typeof eaAreaProperty === 'undefined' || eaAreaProperty === null
            ? ''
            : eaAreaProperty.toString(),
      })
    );
  }
  /**
   * 通过物业项目名称和物业项目编码获取添加在管物业项目数据
   * token:String, name:String, orgName:String, isUpdate:int, checkStatus:int, isInCity:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetEaAreaByNameAndCode (token, name, code, isRemove) {
    return request.post(
      this.baseurl + 'getEaAreaByNameAndCode',
      Qs.stringify({ token: token, name: name, code: code, isRemove })
    );
  }
  /**
   * 获取物业项目搜索意见
   * token:String, eaAreaName:String,
   */
  GetInputSuggest (token, eaAreaName) {
    return request.post(
      this.baseurl + 'getInputSuggest',
      Qs.stringify({ token: token, eaAreaName: eaAreaName })
    );
  }
  /**
     * 搜寻输入建议
     * token:String, eaAreaName:String, eaAreaExternalCode:String, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
  getInputSuggest1(token, eaAreaName, eaAreaExternalCode, startIndex, maxSize, resultTotalCount){
    return request.post(this.baseurl + 'getInputSuggest1', Qs.stringify({ token:token, eaAreaName:eaAreaName, eaAreaExternalCode:eaAreaExternalCode, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
  } 
  /**
   * 是否提交了年报
   * token:String, orgCode:String,
   */
  GetReportState (token, orgCode) {
    return request.post(
      this.baseurl + 'getReportState',
      Qs.stringify({ token: token, orgCode: orgCode })
    );
  }
  /**
   * 是否为独立法人
   * token:String,
   */
  IsIndependentLegal (token) {
    return request.post(
      this.baseurl + 'isIndependentLegal',
      Qs.stringify({ token: token })
    );
  }
  /**
   * 合同来源
   * token:String,
   */
  FindContractByEaAreaCode (token, code, sourceType) {
    return request.post(
      this.baseurl + 'findContractByEaAreaCode',
      Qs.stringify({ token: token, code: code, sourceType: sourceType })
    );
  }
  getLogicDeletedEaArea (token, para, start, size) {
    return request.post(
      this.baseurl + 'getLogicDeletedEaArea',
      Qs.stringify({ token: token, para: para, start: start, size: size })
    );
  }
  logicDeleteEaArea (token, wybh, deleteReason) {
    return request.post(
      this.baseurl + 'logicDeleteEaArea',
      Qs.stringify({ token: token, wybh: wybh, deleteReason: deleteReason })
    );
  }
  /**
   * 物业编号搜搜建议
   */
  querySuggest (token, wybh) {
    return request.post(
      this.baseurl + 'querySuggest',
      Qs.stringify({ token: token, wybh: wybh })
    );
  }
  /**
   * 获取行政区、街道、社区名字
   */
  getCantonAndStreetAndComName (cantonCode, streetCode, comCode) {
    return request.post(
      this.baseurl + 'getCantonAndStreetAndComName',
      Qs.stringify({
        cantonCode: cantonCode,
        streetCode: streetCode,
        comCode: comCode,
      })
    );
  }

  /**
     * 提交变更在管项目
     * token:String, importSzProject:ImportSzProject, applyType:int, applyRemarks:String, contactPerson:String, contactTel:String, AttachmentId:String, subCompanyOrgCode:String, subCompanyOrgName:String, applyReason:String
     */
  submitModifySzProject(token, importSzProject, applyType, applyRemarks, contactPerson, contactTel, AttachmentId, subCompanyOrgCode, subCompanyOrgName, applyReason){
      return request.post(this.baseurl + 'submitModifySzProject', Qs.stringify({ token:token, importSzProject:(typeof importSzProject === 'undefined' || importSzProject === null) ? '' : importSzProject.toString(), applyType:applyType, applyRemarks:applyRemarks, contactPerson:contactPerson, contactTel:contactTel, AttachmentId:AttachmentId, subCompanyOrgCode:subCompanyOrgCode, subCompanyOrgName:subCompanyOrgName, applyReason:applyReason }));
  }

  /**
   * 根据物业项目名称判断是否在某行政区中有重复名称的物业项目
   * eaAreaName:String, cantonCode:String
   */
  isRepeatEaAreaByRepeatNameInTheCanton (eaAreaName, cantonCode) {
    return request.post(
      this.baseurl + 'isRepeatEaAreaByRepeatNameInTheCanton',
      Qs.stringify({ eaAreaName: eaAreaName, cantonCode: cantonCode })
    );
  }
  GetEaAreaDetailByYWD (token, ywdId, type) {
    return request.post(
      this.baseurl + 'GetEaAreaDetailByYWD',
      Qs.stringify({ token, ywdId, type })
    );
  }
  canReport (token) {
    return request.post(this.baseurl + 'canReport', Qs.stringify({ token }));
  }
  /**
 * 模糊搜索全市小区列表
 * eaAreaCode:String, openId:String
 */
  getEaAreaListByParam (
    token,
    param,
    detail,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaListByParam',
      Qs.stringify({
        token,
        param,
        detail,
        startIndex,
        maxSize,
        resultTotalCount,
      })
    );
  }

  /**
   * 查询各行政区域物业项目统计数据
   *
   */
  queryEaAreaXmlxStatisticalDTOByCantonCode() {
    return request.post(
      this.baseurl + 'queryEaAreaXmlxStatisticalDTOByCantonCode',
      Qs.stringify({})
    );
  }

  /**
   * 根据行政区域编码查询各街道物业项目统计数据
   * jgdm:String
   */
  queryEaAreaXmlxStatisticalDTOByStreet(jgdm) {
    return request.post(
      this.baseurl + 'queryEaAreaXmlxStatisticalDTOByStreet',
      Qs.stringify({ jgdm: jgdm })
    );
  }

    /**
   * 根据街道编码查询各社区工作站物业项目统计数据
   * jgdm:String
   */
    queryEaAreaXmlxStatisticalDTOByStation(jgdm) {
      return request.post(
        this.baseurl + 'queryEaAreaXmlxStatisticalDTOByStation',
        Qs.stringify({ jgdm: jgdm })
      );
    }

  /**
   * 根据社区工作站编码查询社区工作站物业项目统计数据
   * jgdm:String
   */
  queryEaAreaXmlxStatisticalDTOBySingleStation(jgdm) {
    return request.post(
      this.baseurl + 'queryEaAreaXmlxStatisticalDTOBySingleStation',
      Qs.stringify({ jgdm: jgdm })
    );
  }


}
